import { axiosInstance } from '@/lib/axios';
import { TimesheetAdditionalConfigurationRaw } from './types';

type Props = {
  companyId: string
}

export function getTimesheetAdditionalSettings({ companyId }: Props) {
  return axiosInstance.get<TimesheetAdditionalConfigurationRaw>(`/api/${companyId}/configuration/timesheetAdditional`);
}
